<template>
  <v-dialog
      v-model="show"
      :max-width="'1200px'"
      scrollable
  >
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            <span class="text-h6">{{ formatedDate }}</span>
          </v-col>
          <v-chip v-if="overview.rb"
                  style="margin-left: auto;
            margin-right: 12px;
            margin-top: auto;
            margin-bottom: auto;"

                  :class="{'soll-ist': true, 'zero': true, 'hidden': overview.rb === ''}"
          >
            <strong>RB: {{overview.rb}}</strong>
          </v-chip>
          <v-chip
              style="
            margin-right: 16px;
            margin-top: auto;
            margin-bottom: auto;"
              :style="{'margin-left': overview.rb ? '8px' : 'auto'}"

              :class="{'soll-ist': true, 'neg': overview.user_day.soll > overview.user_day.ist, 'pos': overview.user_day.soll <= overview.user_day.ist}"
          >
            <strong>Soll: {{formateHours(overview.user_day.soll)}}&nbsp;&nbsp;|&nbsp;&nbsp;Ist: {{formateHours(overview.user_day.ist)}}</strong>
          </v-chip>
            <v-btn icon @click="show = false" style="margin-top: 8px">
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text style="max-height: 60vh">
        <v-row>
          <v-col>
            <v-card-title style="padding: 6px; font-size: 1rem; padding-left: 12px; margin-top: 6px">
              Tagesablauf
            </v-card-title>
            <v-divider style="margin: 0"></v-divider>
            <v-data-table
                dense
                :headers="userDayHeaders"
                :items="overview.time_blocks"
                height="100%"
                hide-default-footer
                disable-pagination
                item-key="id"
                single-expand
                show-expand
                fixed-header
                no-data-text="Keine Daten vorhanden."
                ref="user_day_table"
                :item-class="getItemClass"
                @click:row="onExpand"
            >
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row v-for="child in item.children" :key="child.id" class="m-0">
                    <v-col md="1" class="p-1"></v-col>
                    <v-col class="p-1"  md="1">
                      <v-icon aria-label="Typ" role="img" aria-hidden="false"
                      >
                        {{child.type === 'FAGE' ? 'mdi-car' : child.type === 'LOHN' ? 'mdi-cash' : 'mdi-toolbox'}}
                      </v-icon>
                    </v-col>
                    <v-col class="p-1">
                      {{child.type === 'ARTI' ? 'Menge: ' + child.std : 'Dauer: ' + child.std + ' Std.'}}
                    </v-col>
                    <v-col class="p-1">
                      {{child.title}}
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template v-slot:item.data-table-expand="{ item }">
                <button v-if="item.children !== null && item.children.length" type="button" :class="{
              'v-icon': true,
              'notranslate': true,
               'v-data-table__expand-icon': true,
                'v-icon--link': true,
                 'mdi':true,
                  'mdi-chevron-down': true,
                   'theme--light': true,
                  'v-data-table__expand-icon--active': currentExpand === item.id}" @click.stop="onExpand(item)"></button>
              </template>
            </v-data-table>
          </v-col>
          <v-col style="">
            <v-card-title style="padding: 6px; font-size: 1rem; padding-left: 12px; margin-top: 6px">
              Zulagen
            </v-card-title>
            <v-divider style="margin: 0"></v-divider>
            <v-data-table
                dense
                :headers="headers_surcharges"
                :items="items_surcharges"
                hide-default-footer
                disable-pagination
                disable-sort
                no-data-text="Keine Daten vorhanden."
            ></v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="green darken-1"
            text
            v-on:click.stop="$emit('goto-day'); show = false"
        >
          Tag anzeigen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            v-on:click.stop="show = false"
        >
          Schließen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _orderBy from "lodash/orderBy";
import {getUid} from "@/shared/crypto";

export default {
  name: "UserDayOverview",
  props: {
    date: {
      type: String,
      default () {
        return new Date().toISOString().substr(0, 10);
      }
    },
    overview: {
      type: Object,
      default: () => ({
        user_day: {
          soll: 0.0,
          ist: 0.0,
          valence: 0.0,
          has_rufbereitschaft: false,
        },
        time_blocks: [],
        time_surcharges: 0.0,
        ueb_performed: 0.0,
        roundings: 0.0,
        rounding_entries: [],
        rb: "",
        surcharges: [],
      })
    },
  },
  mounted () {
  },
  watch: {
    date(newVal, oldVal) {
      this.currentBlock = -1;
      if (this.currentExpand) {
        this.$refs.user_day_table.expand(this.currentExpand, false);
        this.currentExpand = null;
      }
    },
    overview: {
      handler(newVal, oldVal) {
        this.currentBlock = -1;
        if (this.currentExpand) {
          this.$refs.user_day_table.expand(this.currentExpand, false);
          this.currentExpand = null;
        }
      },
      deep: true,
    },
  },
  data: () => ({
    show: false,
    headers_surcharges: [
      { text: 'Dauer', value: 'amount', sortable: false,},
      { text: 'Zulage', value: 'name', sortable: false,},
    ],
    items_surcharges: [],
    userDayHeaders: [
      {
        text: 'Von',
        value: 'von',
        sortable: false,
      },
      {
        text: 'Bis',
        value: 'bis',
        sortable: false,
      },
      {
        text: 'Std',
        value: 'std',
        sortable: false,
      },
      { text: 'Titel', value: 'task', sortable: false, },
      { text: 'Leistung', value: 'legr', sortable: false, },
      { text: '', value: 'data-table-expand' },
    ],
    currentExpand: null,
    currentBlock: -1,
  }),
  computed: {
    formatedDate() {
      let splits = this.date.split("-");
      return splits.reverse().join(".");
    },
  },
  methods: {
    onExpand(item, scroll = true) {
      if (item === null || this.currentExpand === item.id) {
        this.currentExpand = null;
        this.$refs.user_day_table.expand(item, false)
      } else {
        this.currentExpand = item.id;
        this.$refs.user_day_table.expand(item, true)
      }
      this.currentBlock = -1;
      for (let i = 0; i < this.overview.time_blocks.length; i++) {
        if (this.overview.time_blocks[i].id === this.currentExpand) {
          this.currentBlock = i;
          if (!this.overview.time_blocks[i].children || this.overview.time_blocks[i].children.length === 0) {
            this.$refs.user_day_table.expand(item, false)
          }
          break;
        }
      }
      this.selectDay();
    },
    getItemClass(item) {
      return item.id === this.currentExpand ? 'row-focused' : '';
    },
    openDialog() {
      this.show = true;
      this.$nextTick(() => {
        this.selectDay();
      });
    },
    selectDay() {
      //this.getUserPresence();
      let surs = [];
      let current = this.overview;
      let currentBlock = this.currentBlock !== -1 ? this.overview.time_blocks[this.currentBlock] : undefined;
      for (let i = 0; i < current.rounding_entries.length; i++) {
        if (!currentBlock || (current.rounding_entries[i].von === currentBlock.von && current.rounding_entries[i].bis === currentBlock.bis)) {
          surs.push({
            amount: this.unformateHours(current.rounding_entries[i].std),
            name: "Rundung",
            type: 'PE02'
          });
        }
      }
      for (let i = 0; i < this.overview.surcharges.length; i++) {
        if (!currentBlock || (this.overview.surcharges[i].von === currentBlock.von && this.overview.surcharges[i].bis === currentBlock.bis)) {
          surs.push(this.overview.surcharges[i]);
        }
      }
      // add up the surcharges
      let finalSurs = [];
      surs.forEach(sur => {
        let found = false;
        for (let i = 0; i < finalSurs.length; i++) {
          if (finalSurs[i].name === sur.name) {
            finalSurs[i].amount += sur.amount;
            found = true;
            break;
          }
        }
        if (!found) {
          finalSurs.push({
            name: sur.name,
            amount: sur.amount,
            type: sur.type,
          });
        }
      });
      // order by name
      finalSurs = _orderBy(finalSurs, 'name');
      // format amount to hh:mm
      finalSurs.forEach(sur => {
        if (sur.type === 'PE02') {
          sur.amount = this.formateHours(sur.amount) + " Std.";
        } else {
          sur.amount = (this.roundToDigits(sur.amount, 2) + "").replace('.', ',');
        }
      });
      this.items_surcharges = finalSurs;
    },
    formateHours(hours) {
      return Math.floor(hours) + ":" + ("0" + (hours % 1 * 60)).slice(-2);
    },
    unformateHours(hoursStr) {
      let parts = hoursStr.split(":");
      return parseInt(parts[0]) + (parseInt(parts[1]) / 60);
    },
    roundToDigits (number, digits) {
      const roundTo = Math.pow(10, digits)
      return (Math.round(number * roundTo) / roundTo).toFixed(2)
    },
  },
}
</script>

<style lang="scss">
:v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.soll-ist {
  margin-top: 4px;
}

.soll-ist.undefined {
  background-color: rgb(161, 149, 149) !important;
  border-color: rgb(161, 149, 149) !important;
  color: white;
}

.soll-ist.zero {
  background-color: rgb(255, 185, 0) !important;
  border-color: rgb(255, 185, 0) !important;
  color: white;
}

.soll-ist.neg {
  background-color: rgb(255, 69, 0)!important;
  border-color: rgb(255, 69, 0)!important;
  color: white;
}

.soll-ist.pos {
  background-color: rgb(1, 109, 3)!important;
  border-color: rgb(1, 109, 3)!important;
  color: white;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

::v-deep .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0 4px 4px -6px rgba(50, 50, 50, 0.75), inset 0 -4px 4px -6px rgba(50, 50, 50, 0.75)
}

::v-deep .v-event-timed:has(> .event-focused) {
  border: 2px solid black !important;
}

::v-deep .row-focused {
  background-color: #b8ccfa !important;
}

.row-focused {
  background-color: #b8ccfa !important;
}


</style>
